import React from 'react'

import { Typography, TextField } from '@material-ui/core' // OK

import { ZariContext } from '_zari/context'
import { Portlet, Button, Col, Row, Table } from '_zari/core'

import FechaEmisionFormGroup from './formGroups/fechaEmision'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import TipoDocumentoConstant from 'constants/tiposDeDocumentoSunat'
import EstadosTransferenciasConstant from 'constants/estadosTransferencias'

import * as TransferenciaCrud from 'services/transferencia.service'
import { DateHandler, ZrSwal } from 'utils'
import { AdminContext } from 'contexts/AdminContext'

const portletBreadcrumbs = [
  {
    name: 'Transferencias por Entrada',
    path: `/${CodigosTransaccionesConstant.TRANSFERENCIAS_ENTRADA_LISTA}`
  },
  {
    name: 'Detalles'
  }
]

const MainCard = ({ queryParams, history, transferenciaInfo }) => {
  const __zariContext = React.useContext(ZariContext)
  const __adminContext = React.useContext(AdminContext)

  const fechaDefault = React.useMemo(() => DateHandler.format(new Date()), [])

  // NEW: estados únicos y consistentes
  const [fechaRecepcion, setFechaRecepcion] = React.useState(fechaDefault)
  const [areaRecepcionTexto, setAreaRecepcionTexto] = React.useState('') // NEW (texto)
  const [usuarioRecepcionNombre, setUsuarioRecepcionNombre] = React.useState('') // NEW (texto)

  // NEW: rehidratar cuando llega transferenciaInfo (async)
  React.useEffect(() => {
    if (!transferenciaInfo) return
    setFechaRecepcion(transferenciaInfo.fechaRecepcion || fechaDefault)
    setAreaRecepcionTexto(transferenciaInfo._idAreaRecepcion || '') // NEW: guardado como texto (aunque se llame _id...)
    setUsuarioRecepcionNombre(transferenciaInfo.usuarioRecepcionNombre || '')
  }, [transferenciaInfo, fechaDefault])

  const estaRecibido = transferenciaInfo?.estadoRecepcion !== EstadosTransferenciasConstant.RECEPCION_PENDIENTE

  const recibirTransferencia = () => {
    const arrFecha = (fechaRecepcion || '').split('/')

    if (arrFecha[1] !== __adminContext.mesTrabajo) {
      ZrSwal.showAlert({
        tipo: 'error',
        mensaje: 'Fecha de recepcion es diferente al mes de trabajo.',
        onSuccess: () => { }
      })
      return
    }

    if (!areaRecepcionTexto || !areaRecepcionTexto.trim()) {
      __zariContext.snack('error', 'Debe ingresar el área de recepción (texto).')
      return
    }

    if (!usuarioRecepcionNombre || !usuarioRecepcionNombre.trim()) {
      __zariContext.snack('error', 'Debe ingresar el nombre completo de quien recibió.')
      return
    }

    // MOD: payload debe calzar con tu DTO backend:
    // ConfirmarRecepcionDto: { fechaRecepcion, usuarioRecepcionNombre, _idAreaRecepcion }
    TransferenciaCrud.confirmarRecepcion(transferenciaInfo._id, {
      fechaRecepcion,
      _idAreaRecepcion: areaRecepcionTexto.trim(), // ✅ OJO: el campo se llama así en el back, aunque sea TEXTO
      usuarioRecepcionNombre: usuarioRecepcionNombre.trim()
    })
      .then(() => {
        __zariContext.snack('success', 'La transferencia ha cambiado de estado.')
        history.push(`/${CodigosTransaccionesConstant.TRANSFERENCIAS_ENTRADA_LISTA}${queryParams}`)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  if (!transferenciaInfo) return null

  return (
    <>
      <Portlet>
        <Portlet.Header title='Transferencias por Entrada' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Row>
            <Col md={12}>
              <Typography color='textSecondary'>Estado</Typography>
              <Typography variant='h6' component='h2'>
                {transferenciaInfo.estadoRecepcion
                  ? EstadosTransferenciasConstant.__dictionary[transferenciaInfo.estadoRecepcion].nombre
                  : '--'}
              </Typography>
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>

      <Portlet>
        <Portlet.Body>
          <Row>
            <Col md={2}>
              <Typography color='textSecondary'>Establecimiento Origen</Typography>
              <Typography variant='h6' component='h2'>
                {transferenciaInfo.sedeOrigen}
              </Typography>
            </Col>

            <Col md={2}>
              <Typography color='textSecondary'>Usuario</Typography>
              <Typography variant='h6' component='h2'>
                {transferenciaInfo.usuario}
              </Typography>
            </Col>

            <Col md={2}>
              <Typography color='textSecondary'>Tipo de Doc. Emisión</Typography>
              <Typography variant='h6' component='h2'>
                {transferenciaInfo.tipoDocumento
                  ? TipoDocumentoConstant.__dictionary[transferenciaInfo.tipoDocumento].nombre
                  : '--'}
              </Typography>
            </Col>

            <Col md={2}>
              <Typography color='textSecondary'>Fec. Emision</Typography>
              <Typography variant='h6' component='h2'>
                {transferenciaInfo.fechaEmision}
              </Typography>
            </Col>
          </Row>

          {/* ✅ Ajuste de layout a 12 columnas exactas */}
          <Row className='mt-2'>
            <Col md={2}>
              <Typography color='textSecondary'>Establecimiento Destino</Typography>
              <Typography variant='h6' component='h2'>
                {transferenciaInfo.sedeDestino}
              </Typography>
            </Col>

            <Col md={3}>
              <Typography color='textSecondary'>Área que recibe (texto)</Typography>
              <TextField
                value={areaRecepcionTexto}
                onChange={(e) => setAreaRecepcionTexto(e.target.value)}
                fullWidth
                placeholder='Ej: Oficina de Logística / Almacén Central / etc.'
                disabled={estaRecibido}
              />
            </Col>

            <Col md={3}>
              <Typography color='textSecondary'>Usuario que recibió (Nombre completo)</Typography>
              <TextField
                value={usuarioRecepcionNombre}
                onChange={(e) => setUsuarioRecepcionNombre(e.target.value)}
                fullWidth
                placeholder='Ej: Juan Pérez Gómez'
                disabled={estaRecibido}
              />
            </Col>

            <Col md={2}>
              <Typography color='textSecondary'>Num. de Doc. Emisión</Typography>
              <Typography variant='h6' component='h2'>
                {transferenciaInfo.serieDocumento} - {transferenciaInfo.numeroDocumento}
              </Typography>
            </Col>

            <Col md={2}>
              <Typography color='textSecondary'>Fec. Recepcion</Typography>
              <FechaEmisionFormGroup
                value={fechaRecepcion}
                onChange={(e) => setFechaRecepcion(e.target.value)}
                disabled={estaRecibido} // NEW (si tu componente lo soporta)
              />
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>

      <Portlet>
        <Portlet.Body>
          <Row>
            <Col md={12}>
              <Typography color='textSecondary'>Comentario</Typography>
              <Typography variant='h6' component='h2'>
                {transferenciaInfo.comentario || 'No hay comentarios disponibles.'}
              </Typography>
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>

      <Portlet>
        <Portlet.Body>
          <Table.ClientSide
            headRows={[{ label: 'PRODUCTO' }, { label: 'PRESENTACION' }, { label: 'CANTIDAD' }]}
            filas={transferenciaInfo.detalles || []}
            rowTemplate={(row, k) => (
              <Table.Row hover key={k}>
                <Table.Cell>{row.producto || '--'}</Table.Cell>
                <Table.Cell>{row.presentacion || '--'}</Table.Cell>
                <Table.Cell>{row.cantidad || '--'}</Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>

      {transferenciaInfo.estadoRecepcion === EstadosTransferenciasConstant.RECEPCION_PENDIENTE && (
        <Portlet>
          <Portlet.Body>
            <Col md={12} className='text-right'>
              <Button onClick={recibirTransferencia}>Recibir</Button>
            </Col>
          </Portlet.Body>
        </Portlet>
      )}
    </>
  )
}

export default MainCard
